/* UTV Wholesaler — Year/Make/Model finder, My Garage, fitment badges and UI helpers */
(function () {
  'use strict';
  var V = window.UTVW_VEHICLES || [];
  var BYK = {};
  V.forEach(function (v) { BYK[v.k] = v; });
  var MAKES = [];
  V.forEach(function (v) { if (MAKES.indexOf(v.mk) === -1) MAKES.push(v.mk); });
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'utvw_garage_v1';

  /* ---------- storage ---------- */
  function read() {
    try {
      var g = JSON.parse(localStorage.getItem(KEY));
      if (g && Array.isArray(g.list)) return g;
    } catch (e) {}
    return { list: [], active: null };
  }
  function write(g) {
    try { localStorage.setItem(KEY, JSON.stringify(g)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('utvw:garage', { detail: g }));
  }
  function vid(v) { return v.k + '|' + v.y; }
  function valid(v) {
    var d = v && BYK[v.k];
    return !!(d && v.y >= d.y[0] && v.y <= d.y[1]);
  }
  function active() {
    var g = read();
    return valid(g.active) ? g.active : null;
  }
  function addVehicle(v) {
    if (!valid(v)) return;
    var g = read();
    g.list = g.list.filter(function (x) { return valid(x) && vid(x) !== vid(v); });
    g.list.unshift({ k: v.k, y: +v.y });
    g.list = g.list.slice(0, 6);
    g.active = { k: v.k, y: +v.y };
    write(g);
  }
  function removeVehicle(id) {
    var g = read();
    g.list = g.list.filter(function (x) { return vid(x) !== id; });
    if (g.active && vid(g.active) === id) g.active = g.list[0] || null;
    write(g);
  }
  function setActive(id) {
    var g = read();
    var hit = g.list.filter(function (x) { return vid(x) === id; })[0];
    if (hit) { g.active = hit; write(g); }
  }
  function shortModel(md) { return md.split(' / ')[0].replace(/\s*\(.*\)\s*$/, ''); }
  function label(v, short) {
    var d = v && BYK[v.k];
    if (!d) return '';
    return v.y + ' ' + d.mk + ' ' + (short ? shortModel(d.md) : d.md);
  }
  function vehicleUrl(v) { return ROOT + 'collections/' + v.k + '-accessories?yr=' + v.y; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  window.UTVW = { vehicles: V, byKey: BYK, read: read, active: active, add: addVehicle, remove: removeVehicle, label: label, url: vehicleUrl };

  /* ---------- fitment ---------- */
  function parseFit(str) {
    return (str || '').split('|').filter(Boolean).map(function (s) {
      var p = s.split(':');
      var r = (p[1] || '').split('-');
      var a = parseInt(r[0], 10) || 0;
      var b = parseInt(r[1], 10) || a || 9999;
      return { k: p[0], a: a, b: b };
    });
  }
  function fitStatus(el, v) {
    if (!v) return null;
    var fits = parseFit(el.getAttribute('data-fit'));
    var uni = el.getAttribute('data-uni') === '1';
    var same = fits.filter(function (f) { return f.k === v.k; });
    if (same.some(function (f) { return v.y >= f.a && v.y <= f.b; })) return 'fit';
    if (uni) return 'uni';
    if (same.length) return 'year';
    if (fits.length) return 'nofit';
    return 'unknown';
  }
  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var ICON_U = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17M12 3.5c2.5 2.6 2.5 14.4 0 17M12 3.5c-2.5 2.6-2.5 14.4 0 17"/></svg>';

  function chipFor(state, v) {
    var s = label(v, true);
    if (state === 'fit') return '<span class="utvw-chip utvw-chip--fit">' + ICON_OK + 'Fits your ' + esc(s) + '</span>';
    if (state === 'uni') return '<span class="utvw-chip utvw-chip--uni">' + ICON_U + 'Universal fit</span>';
    if (state === 'year' || state === 'nofit') return '<span class="utvw-chip utvw-chip--nofit">' + ICON_X + 'Not for your ' + esc(s) + '</span>';
    return '';
  }

  function paintCards(scope) {
    var v = active();
    var cards = (scope || document).querySelectorAll('[data-utvw-card]');
    var stats = { total: 0, fit: 0, uni: 0 };
    cards.forEach(function (card) {
      var slot = card.querySelector('.utvw-fit-slot');
      var st = fitStatus(card, v);
      card.setAttribute('data-fit-state', st || 'none');
      if (slot) slot.innerHTML = st ? chipFor(st, v) : '';
      stats.total++;
      if (st === 'fit') stats.fit++;
      if (st === 'uni') stats.uni++;
    });
    applyOnlyFit();
    document.querySelectorAll('[data-utvw-fitcount]').forEach(function (el) {
      el.textContent = v ? (stats.fit + stats.uni) + ' of ' + stats.total + ' on this page fit' : '';
    });
    return stats;
  }

  function applyOnlyFit() {
    var on = false;
    try { on = sessionStorage.getItem('utvw_onlyfit') === '1'; } catch (e) {}
    var v = active();
    document.querySelectorAll('[data-utvw-onlyfit]').forEach(function (i) { i.checked = on && !!v; i.disabled = !v; });
    document.querySelectorAll('[data-utvw-card]').forEach(function (card) {
      var st = card.getAttribute('data-fit-state');
      var hide = on && v && !(st === 'fit' || st === 'uni');
      var item = card.closest('.grid__item') || card;
      item.classList.toggle('utvw-hide', !!hide);
    });
  }

  function paintPanels() {
    var v = active();
    document.querySelectorAll('[data-utvw-fitpanel]').forEach(function (p) {
      var st = fitStatus(p, v);
      var box = p.querySelector('[data-utvw-fitstatus]');
      if (!box) return;
      var html, state;
      if (!v) {
        state = 'none';
        html = ICON_U.replace('<svg', '<svg style="opacity:.6"') + '<span>Select your vehicle to confirm this part fits.</span><button type="button" data-utvw-open-garage>Add vehicle</button>';
      } else if (st === 'fit') {
        state = 'fit';
        html = ICON_OK + '<span>Fits your <strong>' + esc(label(v)) + '</strong></span><button type="button" data-utvw-open-garage>Change</button>';
      } else if (st === 'uni') {
        state = 'uni';
        html = ICON_U + '<span>Universal fit &mdash; check the specs for your <strong>' + esc(label(v, true)) + '</strong></span><button type="button" data-utvw-open-garage>Change</button>';
      } else if (st === 'unknown') {
        state = 'none';
        html = ICON_U + '<span>Check the fitment notes below for your <strong>' + esc(label(v, true)) + '</strong></span><button type="button" data-utvw-open-garage>Change</button>';
      } else {
        state = 'nofit';
        html = ICON_X + '<span>Does not list your <strong>' + esc(label(v)) + '</strong></span><button type="button" data-utvw-open-garage>Change</button>';
      }
      box.setAttribute('data-state', state);
      box.innerHTML = html;
    });
  }

  function paintGarageButtons() {
    var v = active();
    document.querySelectorAll('[data-utvw-garage-btn]').forEach(function (b) {
      var t = b.querySelector('.utvw-garage-btn__veh');
      if (v) { b.setAttribute('data-has-vehicle', ''); if (t) t.textContent = label(v, true); b.setAttribute('aria-label', 'My Garage: ' + label(v)); }
      else { b.removeAttribute('data-has-vehicle'); if (t) t.textContent = t.getAttribute('data-empty') || 'Add vehicle'; b.setAttribute('aria-label', 'My Garage: add your vehicle'); }
    });
    document.querySelectorAll('[data-utvw-active-label]').forEach(function (el) { el.textContent = v ? label(v) : (el.getAttribute('data-empty') || 'No vehicle selected'); });
    document.querySelectorAll('[data-utvw-if-vehicle]').forEach(function (el) { el.hidden = !v; });
    document.querySelectorAll('[data-utvw-if-novehicle]').forEach(function (el) { el.hidden = !!v; });
    document.querySelectorAll('.utvw-fitbar').forEach(function (el) { el.classList.toggle('utvw-fitbar--empty', !v); });
    renderGarageList();
  }

  function renderGarageList() {
    var g = read();
    var a = active();
    document.querySelectorAll('[data-utvw-garage-list]').forEach(function (ul) {
      var items = g.list.filter(valid);
      ul.innerHTML = items.map(function (x) {
        var on = a && vid(a) === vid(x);
        return '<li' + (on ? ' data-active' : '') + '><a href="' + vehicleUrl(x) + '">' + esc(label(x)) + '</a>' +
          (on ? '<span class="utvw-chip utvw-chip--yellow">Active</span>' : '<button type="button" data-utvw-set="' + vid(x) + '">Select</button>') +
          '<button type="button" data-utvw-del="' + vid(x) + '" aria-label="Remove ' + esc(label(x)) + '">Remove</button></li>';
      }).join('');
      var h = ul.previousElementSibling;
      if (h && h.classList.contains('utvw-garage-list__h')) h.hidden = !items.length;
    });
  }

  function repaint() { paintGarageButtons(); paintCards(); paintPanels(); paintYearChips(); }

  /* ---------- finder element ---------- */
  function opt(v, t, sel) { var o = document.createElement('option'); o.value = v; o.textContent = t; if (sel) o.selected = true; return o; }

  class UtvwFinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.mk = this.querySelector('[data-role=make]');
      this.md = this.querySelector('[data-role=model]');
      this.yr = this.querySelector('[data-role=year]');
      this.go = this.querySelector('[data-role=go]');
      this.form = this.querySelector('form');
      if (!this.mk || !this.md || !this.yr) return;
      var self = this;
      MAKES.forEach(function (m) { self.mk.appendChild(opt(m, m)); });
      this.mk.addEventListener('change', function () { self.fillModels(); self.sync(); });
      this.md.addEventListener('change', function () { self.fillYears(); self.sync(); });
      this.yr.addEventListener('change', function () { self.sync(); });
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
      var preset = this.getAttribute('data-preset');
      var v = active();
      if (preset && BYK[preset]) {
        this.select(preset, v && v.k === preset ? v.y : null);
      } else if (v) {
        this.select(v.k, v.y);
      }
      this.sync();
      document.addEventListener('utvw:garage', function () { var a = active(); if (a && !self.contains(document.activeElement)) { self.select(a.k, a.y); self.sync(); } });
    }
    select(k, y) {
      var d = BYK[k];
      if (!d) return;
      this.mk.value = d.mk;
      this.fillModels();
      this.md.value = k;
      this.fillYears();
      if (y) this.yr.value = String(y);
    }
    fillModels() {
      var mk = this.mk.value;
      this.md.innerHTML = '';
      this.md.appendChild(opt('', mk ? 'Select model' : 'Select make first'));
      var self = this;
      V.filter(function (v) { return v.mk === mk; }).forEach(function (v) { self.md.appendChild(opt(v.k, v.md + ' (' + v.y[0] + '–' + v.y[1] + ')')); });
      this.md.disabled = !mk;
      this.fillYears();
    }
    fillYears() {
      var d = BYK[this.md.value];
      this.yr.innerHTML = '';
      this.yr.appendChild(opt('', d ? 'Select year' : 'Select model first'));
      if (d) for (var y = d.y[1]; y >= d.y[0]; y--) this.yr.appendChild(opt(y, y));
      this.yr.disabled = !d;
    }
    sync() {
      [this.mk, this.md, this.yr].forEach(function (s) { s.closest('.utvw-select').classList.toggle('is-done', !!s.value); });
      if (this.go) this.go.disabled = !(this.md.value && this.yr.value);
    }
    submit() {
      var v = { k: this.md.value, y: parseInt(this.yr.value, 10) };
      if (!valid(v)) return;
      addVehicle(v);
      var mode = this.getAttribute('data-mode') || 'navigate';
      var dlg = this.closest('dialog');
      if (mode === 'stay') { if (dlg) dlg.close(); repaint(); return; }
      window.location.href = vehicleUrl(v);
    }
  }
  if (!customElements.get('utvw-finder')) customElements.define('utvw-finder', UtvwFinder);

  /* ---------- year chips on vehicle hubs ---------- */
  function paintYearChips() {
    var v = active();
    document.querySelectorAll('[data-utvw-years]').forEach(function (wrap) {
      var k = wrap.getAttribute('data-utvw-years');
      var d = BYK[k];
      if (!d) return;
      if (!wrap.childElementCount) {
        var h = '';
        for (var y = d.y[1]; y >= d.y[0]; y--) h += '<button type="button" data-y="' + y + '" aria-pressed="false">' + y + '</button>';
        wrap.innerHTML = h;
      }
      wrap.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', v && v.k === k && String(v.y) === b.getAttribute('data-y') ? 'true' : 'false'); });
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-utvw-open-garage]');
    if (t) {
      e.preventDefault();
      var d = document.getElementById('utvw-garage');
      if (d && d.showModal) { d.showModal(); var s = d.querySelector('select:not([disabled])'); if (s) setTimeout(function () { s.focus(); }, 60); }
      return;
    }
    var c = e.target.closest('[data-utvw-close]');
    if (c) { var dd = c.closest('dialog'); if (dd) dd.close(); return; }
    var del = e.target.closest('[data-utvw-del]');
    if (del) { removeVehicle(del.getAttribute('data-utvw-del')); return; }
    var set = e.target.closest('[data-utvw-set]');
    if (set) { setActive(set.getAttribute('data-utvw-set')); return; }
    var clr = e.target.closest('[data-utvw-clear]');
    if (clr) { var g = read(); g.active = null; write(g); return; }
    var yc = e.target.closest('[data-utvw-years] button');
    if (yc) { addVehicle({ k: yc.closest('[data-utvw-years]').getAttribute('data-utvw-years'), y: parseInt(yc.getAttribute('data-y'), 10) }); return; }
    var more = e.target.closest('[data-utvw-more]');
    if (more) { var b = document.getElementById(more.getAttribute('aria-controls')); if (b) { var open = b.classList.toggle('is-clamped') === false; more.setAttribute('aria-expanded', open); more.textContent = open ? 'Show less' : 'Read more'; } }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-utvw-onlyfit]')) {
      try { sessionStorage.setItem('utvw_onlyfit', e.target.checked ? '1' : '0'); } catch (x) {}
      applyOnlyFit();
    }
  });
  document.addEventListener('click', function (e) {
    var d = e.target;
    if (d && d.tagName === 'DIALOG' && d.classList.contains('utvw-modal')) d.close();
  });
  document.addEventListener('utvw:garage', repaint);

  /* re-paint after Dawn re-renders the product grid (filters, sorting, pagination) */
  function watchGrid() {
    var grid = document.getElementById('ProductGridContainer') || document.querySelector('.collection');
    if (!grid || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { paintCards(); }, 40); }).observe(grid, { childList: true, subtree: true });
  }

  /* vehicle collection: ?yr=YYYY selects the vehicle */
  function adoptUrlVehicle() {
    var host = document.querySelector('[data-utvw-vehicle-key]');
    if (!host) return;
    var k = host.getAttribute('data-utvw-vehicle-key');
    var m = /[?&]yr=(\d{4})/.exec(location.search);
    if (m && BYK[k]) {
      var v = { k: k, y: parseInt(m[1], 10) };
      var a = active();
      if (valid(v) && (!a || vid(a) !== vid(v))) addVehicle(v);
    }
  }

  /* ---------- reveal on scroll ---------- */
  function reveal() {
    var els = document.querySelectorAll('.utvw-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- sticky add-to-cart on mobile ---------- */
  function stickyAtc() {
    var bar = document.querySelector('.utvw-sticky-atc');
    var btn = document.querySelector('.product-form__submit');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var e = en[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(btn);
    bar.querySelector('button').addEventListener('click', function () { btn.click(); });
  }

  function init() {
    adoptUrlVehicle();
    repaint();
    watchGrid();
    reveal();
    stickyAtc();
    document.querySelectorAll('[data-utvw-clamp]').forEach(function (b) { if (b.scrollHeight > 420) { b.classList.add('is-clamped'); var m = b.parentNode.querySelector('[data-utvw-more]'); if (m) m.hidden = false; } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ==========================================================================
   UTVW motion layer: scroll progress, hero motion, scroll-linked parallax,
   staggered reveals, tilt cards, magnetic buttons, marquee, cart burst.
   ========================================================================== */
(function () {
  'use strict';
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var FINE = mq('(hover: hover) and (pointer: fine)');
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;

  /* ---------- scroll progress, header state, back-to-top ---------- */
  function chrome() {
    var bar = document.createElement('div'); bar.className = 'utvw-progress'; bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var top = document.createElement('button'); top.type = 'button'; top.className = 'utvw-top'; top.setAttribute('aria-label', 'Back to top');
    top.innerHTML = '<svg viewBox="0 0 50 50" aria-hidden="true"><circle cx="25" cy="25" r="22"/></svg><i aria-hidden="true">&uarr;</i>';
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: RM ? 'auto' : 'smooth' }); });
    document.body.appendChild(top);
    return function (y, max) {
      var p = max > 0 ? clamp(y / max, 0, 1) : 0;
      bar.style.setProperty('--p', p.toFixed(4));
      top.style.setProperty('--p', p.toFixed(4));
      top.classList.toggle('is-on', y > 700);
      root.classList.toggle('utvw-scrolled', y > 40);
    };
  }

  /* ---------- hero ---------- */
  function splitWords(el) {
    if (!el || el.getAttribute('data-split')) return;
    el.setAttribute('data-split', '1');
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(' ')); return; }
            var o = document.createElement('span'); o.className = 'utvw-w'; o.setAttribute('aria-hidden', 'true');
            var s = document.createElement('span'); s.textContent = w; s.style.setProperty('--i', i++);
            o.appendChild(s); frag.appendChild(o);
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1) { walk(n); }
      });
    })(el);
  }

  function countUp(el) {
    var raw = el.textContent.trim(); var m = raw.match(/^([^\d]*)([\d,]+)(.*)$/);
    if (!m) return;
    var target = parseInt(m[2].replace(/,/g, ''), 10); if (!target || target > 100000) return;
    var t0 = null, dur = 1400, comma = m[2].indexOf(',') > -1;
    el.textContent = m[1] + '0' + m[3];
    function step(ts) {
      if (!t0) t0 = ts; var k = clamp((ts - t0) / dur, 0, 1); k = 1 - Math.pow(1 - k, 3);
      var v = Math.round(target * k); el.textContent = m[1] + (comma ? v.toLocaleString('en-US') : v) + m[3];
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function particles(hero) {
    if (RM || window.innerWidth < 750 || (navigator.connection && navigator.connection.saveData)) return;
    var c = document.createElement('canvas'); c.className = 'utvw-hero__fx'; c.setAttribute('aria-hidden', 'true');
    hero.insertBefore(c, hero.firstChild.nextSibling);
    var ctx = c.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, P = [], on = true, raf = 0;
    function size() { W = hero.clientWidth; H = hero.clientHeight; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function mk(init) {
      return { x: Math.random() * W, y: init ? Math.random() * H : H + 10, r: Math.random() * 1.8 + .4, vx: Math.random() * .35 + .05,
        vy: -(Math.random() * .45 + .12), a: Math.random() * .55 + .15, tw: Math.random() * Math.PI * 2 };
    }
    size(); for (var i = 0; i < 70; i++) P.push(mk(true));
    function frame() {
      if (!on) { raf = 0; return; }
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) {
        var p = P[i]; p.x += p.vx; p.y += p.vy; p.tw += .03;
        if (p.y < -10 || p.x > W + 10) P[i] = p = mk(false);
        var a = p.a * (.6 + .4 * Math.sin(p.tw));
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fillStyle = 'rgba(255,236,140,' + a.toFixed(3) + ')'; ctx.fill();
      }
      raf = requestAnimationFrame(frame);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { on = en[0].isIntersecting; if (on && !raf) raf = requestAnimationFrame(frame); }).observe(hero);
    }
    window.addEventListener('resize', size, { passive: true });
    raf = requestAnimationFrame(frame);
  }

  function spotlight(el) {
    if (!FINE || RM) return;
    var s = document.createElement('span'); s.className = 'utvw-spotlight'; s.setAttribute('aria-hidden', 'true');
    el.appendChild(s);
    el.addEventListener('pointermove', function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--mx', (e.clientX - r.left) + 'px'); el.style.setProperty('--my', (e.clientY - r.top) + 'px');
      el.classList.add('is-lit');
    }, { passive: true });
    el.addEventListener('pointerleave', function () { el.classList.remove('is-lit'); });
  }

  /* ---------- scroll-linked motion ---------- */
  var FX = [];
  function prog(r, vh) { return clamp((vh - r.top) / (vh + r.height), 0, 1); }
  function addFx(el, fn) { if (el) FX.push({ el: el, fn: fn, live: true }); }

  function setupFx() {
    if (RM) return;
    var wide = window.innerWidth >= 990, mid = window.innerWidth >= 750;
    var hero = document.querySelector('.utvw-hero');
    if (hero) {
      var copy = hero.querySelector('.utvw-hero__copy'), glass = hero.querySelector('.utvw-glass'), media = hero.querySelector('.utvw-hero__media');
      addFx(hero, function (r) {
        var p = clamp(-r.top / Math.max(r.height, 1), 0, 1);
        if (media) { media.style.setProperty('--py', (p * r.height * .35).toFixed(1) + 'px'); media.style.setProperty('--ps', (1 + p * .1).toFixed(4)); }
        if (copy) { copy.style.translate = '0 ' + (-p * 90).toFixed(1) + 'px'; copy.style.opacity = (1 - p * 1.1).toFixed(3); }
        if (glass && mid) { glass.style.translate = '0 ' + (-p * 170).toFixed(1) + 'px'; glass.style.scale = (1 - p * .06).toFixed(4); }
      });
    }
    var amps = wide ? [30, 64, 14, 48] : [10, 24, 6, 18];
    $$('.utvw-cat').forEach(function (el, i) {
      var a = amps[i % 4];
      addFx(el, function (r, vh) { el.style.translate = '0 ' + ((.5 - prog(r, vh)) * a).toFixed(1) + 'px'; });
    });
    var vamps = wide ? [20, 70, 36, 90] : [0, 24, 0, 24];
    $$('.utvw-vcard').forEach(function (el, i) {
      var a = vamps[i % 4];
      addFx(el, function (r, vh) { el.style.translate = '0 ' + ((.5 - prog(r, vh)) * a).toFixed(1) + 'px'; });
    });
    var mamps = wide ? [0, 44, 16, 60] : [0, 22];
    $$('.utvw-make').forEach(function (el, i) {
      var a = mamps[i % mamps.length];
      addFx(el, function (r, vh) { el.style.translate = '0 ' + ((.5 - prog(r, vh)) * a).toFixed(1) + 'px'; });
    });
    $$('.utvw-strip').forEach(function (el) {
      var img = el.querySelector('img');
      addFx(el, function (r, vh) {
        var p = prog(r, vh), k = clamp(p / .45, 0, 1);
        el.style.scale = (.88 + .12 * k).toFixed(4); el.style.borderRadius = (64 - 40 * k).toFixed(1) + 'px';
        if (img) img.style.setProperty('--py', ((.5 - p) * 120).toFixed(1) + 'px');
      });
    });
    $$('.utvw-split__media').forEach(function (el) {
      var img = el.querySelector('img');
      addFx(el, function (r, vh) { var p = prog(r, vh); if (img) img.style.setProperty('--py', ((.5 - p) * 90).toFixed(1) + 'px'); el.style.rotate = ((.5 - p) * (mid ? 3 : 0)).toFixed(2) + 'deg'; });
    });
    $$('.utvw-shead h2, .utvw-split h2, .utvw-faq h2, .collection__title .title, .utvw-seo h2').forEach(function (el, i) {
      var dir = i % 2 ? -1 : 1;
      addFx(el, function (r, vh) { var k = clamp(prog(r, vh) * 2.4, 0, 1); el.style.translate = (dir * (1 - k) * (mid ? 70 : 24)).toFixed(1) + 'px 0'; });
    });
    $$('.utvw-chero').forEach(function (el) {
      var img = el.querySelector('.utvw-chero__img');
      addFx(el, function (r) { var p = clamp(-r.top / Math.max(r.height, 1), 0, 1); if (img) { img.style.translate = '0 ' + (p * r.height * .3).toFixed(1) + 'px'; img.style.scale = (1 + p * .08).toFixed(4); } });
    });
    $$('.utvw-marquee__track').forEach(function (el) {
      addFx(el.parentNode, function (r, vh) { el.parentNode.style.translate = ((.5 - prog(r, vh)) * 120).toFixed(1) + 'px 0'; });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { FX.forEach(function (f) { if (f.el === e.target) f.live = e.isIntersecting; }); });
      }, { rootMargin: '25% 0px 25% 0px' });
      FX.forEach(function (f) { io.observe(f.el); });
    }
  }
  function runFx() {
    var vh = window.innerHeight;
    for (var i = 0; i < FX.length; i++) { var f = FX[i]; if (!f.live) continue; f.fn(f.el.getBoundingClientRect(), vh); }
  }

  /* ---------- reveals ---------- */
  function reveals() {
    var groups = [
      ['.utvw-trust__item', 4], ['#product-grid > .grid__item', 4], ['.collection .grid__item', 4], ['.utvw-faq__list details', 1],
      ['.footer-block', 4], ['.utvw-seo > *', 1], ['.utvw-fitbar', 1], ['.utvw-catchips a', 12], ['.product__info-container > *', 10],
      ['.main-page-title', 1], ['.rte > *', 1], ['.utvw-checks li', 6]
    ];
    var els = [];
    groups.forEach(function (g) {
      $$(g[0]).forEach(function (el, i) {
        if (el.classList.contains('utvw-reveal') || el.classList.contains('utvw-rv') || el.closest('.utvw-rv')) return;
        el.classList.add('utvw-rv'); el.style.setProperty('--i', g[1] > 1 ? i % g[1] : 0); els.push(el);
      });
    });
    $$('.utvw-split__media').forEach(function (el) { el.classList.add('utvw-rv--wipe'); els.push(el); });
    if (RM || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
    // catch anything the observer missed (fast jumps, printed pages)
    setTimeout(function () { var vh = window.innerHeight; els.forEach(function (e) { if (e.getBoundingClientRect().top < vh) e.classList.add('is-in'); }); }, 2500);
  }
  function watchNewCards() {
    var grid = document.getElementById('product-grid');
    if (!grid || !('MutationObserver' in window)) return;
    new MutationObserver(function () { $$('#product-grid > .grid__item:not(.utvw-rv)').forEach(function (el) { el.classList.add('utvw-rv', 'is-in'); }); loaded(); })
      .observe(grid, { childList: true });
  }

  /* ---------- tilt + magnetic ---------- */
  function tilt() {
    if (!FINE || RM) return;
    $$('.utvw-cat, .utvw-vcard, .utvw-make, .utvw-club__card, .utvw-club__item').forEach(function (el) {
      el.classList.add('utvw-tilt');
      var g = document.createElement('span'); g.className = 'utvw-glare'; g.setAttribute('aria-hidden', 'true'); el.appendChild(g);
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.classList.add('is-tilting');
        el.style.transform = 'perspective(900px) rotateX(' + ((.5 - y) * 9).toFixed(2) + 'deg) rotateY(' + ((x - .5) * 11).toFixed(2) + 'deg) translateZ(0)';
        el.style.setProperty('--gx', (x * 100).toFixed(1) + '%'); el.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
      }, { passive: true });
      el.addEventListener('pointerleave', function () { el.classList.remove('is-tilting'); el.style.transform = ''; });
    });
  }
  function magnetic() {
    if (!FINE || RM) return;
    $$('.utvw-btn--yellow, .utvw-btn--ghost, .utvw-finder__go').forEach(function (el) {
      el.classList.add('utvw-mag');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.translate = (((e.clientX - r.left) / r.width - .5) * 14).toFixed(1) + 'px ' + (((e.clientY - r.top) / r.height - .5) * 10).toFixed(1) + 'px';
      }, { passive: true });
      el.addEventListener('pointerleave', function () { el.style.translate = ''; });
    });
  }

  /* ---------- marquee of makes (home page) ---------- */
  function marquee() {
    var trust = document.querySelector('.utvw-trust');
    var V = window.UTVW_VEHICLES || [];
    if (!trust || !V.length || document.querySelector('.utvw-marquee')) return;
    var sec = trust.closest('.shopify-section') || trust;
    var makes = []; V.forEach(function (v) { if (makes.indexOf(v.mk) < 0) makes.push(v.mk); });
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var items = makes.map(function (m) { return '<a href="' + base + 'collections/' + m.toLowerCase().replace(/\s+/g, '-') + '-accessories">' + m + ' parts</a>'; }).join('')
      + '<a href="' + base + 'collections/universal-utv-accessories">Universal fit</a><a href="' + base + 'collections/all">New arrivals</a>';
    var w = document.createElement('div'); w.className = 'utvw-marquee-wrap';
    w.innerHTML = '<div class="utvw-marquee" role="navigation" aria-label="Shop by make"><div class="utvw-marquee__track">' + items + '<span aria-hidden="true" style="display:contents">' + items.replace(/<a /g, '<a tabindex="-1" ') + '</span></div></div>';
    sec.parentNode.insertBefore(w, sec.nextSibling);
  }

  /* ---------- image shimmer, cart feedback, toast ---------- */
  function loaded() {
    $$('.card__media:not(.is-loaded)').forEach(function (m) {
      var img = m.querySelector('img');
      if (!img || (img.complete && img.naturalWidth)) { m.classList.add('is-loaded'); return; }
      img.addEventListener('load', function () { m.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { m.classList.add('is-loaded'); }, { once: true });
    });
  }
  function burst(x, y) {
    if (RM) return;
    for (var i = 0; i < 14; i++) {
      var s = document.createElement('span'); s.className = 'utvw-burst';
      var a = Math.random() * 6.283, d = 50 + Math.random() * 70;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--bx', (Math.cos(a) * d).toFixed(0) + 'px'); s.style.setProperty('--by', (Math.sin(a) * d - 30).toFixed(0) + 'px');
      s.style.setProperty('--br', (Math.random() * 540).toFixed(0) + 'deg');
      if (i % 3 === 0) s.style.background = '#0B0D10';
      document.body.appendChild(s); setTimeout(function (n) { n.remove(); }.bind(null, s), 900);
    }
  }
  function cartFx() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.product-form__submit, .quick-add__submit');
      if (!b || b.disabled) return;
      var r = b.getBoundingClientRect(); burst(r.left + r.width / 2, r.top + r.height / 2);
    });
    var icon = document.getElementById('cart-icon-bubble');
    if (icon && 'MutationObserver' in window) {
      new MutationObserver(function () { icon.classList.remove('utvw-bump'); void icon.offsetWidth; icon.classList.add('utvw-bump'); })
        .observe(icon, { childList: true, subtree: true, characterData: true });
    }
  }
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'utvw-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<b aria-hidden="true">&#10003;</b><span></span>'; toastEl.querySelector('span').textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  document.addEventListener('click', function (e) {
    var y = e.target.closest && e.target.closest('[data-utvw-years] button');
    if (y) setTimeout(function () { var l = document.querySelector('[data-utvw-active-label]'); toast('Saved to My Garage' + (l && l.textContent ? ': ' + l.textContent : '')); }, 60);
  });

  /* ---------- boot ---------- */
  function init() {
    var paintChrome = chrome();
    var hero = document.querySelector('.utvw-hero');
    if (hero) {
      if (!RM) splitWords(hero.querySelector('.utvw-hero__title'));
      particles(hero); spotlight(hero);
      var glass = hero.querySelector('.utvw-glass');
      if (glass && !RM) { var sc = document.createElement('span'); sc.className = 'utvw-scan'; sc.setAttribute('aria-hidden', 'true'); glass.appendChild(sc); }
      $$('.utvw-hero__proof strong').forEach(function (s) { if (!RM) setTimeout(function () { countUp(s); }, 900); });
    }
    $$('.utvw-strip, .utvw-trust, .utvw-chero').forEach(spotlight);
    marquee();
    reveals(); watchNewCards(); loaded();
    tilt(); magnetic(); cartFx();
    setupFx();
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = window.scrollY || window.pageYOffset, max = document.documentElement.scrollHeight - window.innerHeight;
        paintChrome(y, max); runFx();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ==========================================================================
   Vehicle-based email + order tagging: every customer email form carries the
   rider's My Garage vehicles as customer tags, and the cart carries the
   active vehicle as a cart attribute (shows on the order).
   ========================================================================== */
(function () {
  'use strict';
  var KEY = 'utvw_garage_v1';
  function garage() { try { var g = JSON.parse(localStorage.getItem(KEY) || 'null'); return g && g.list ? g : { list: [] }; } catch (e) { return { list: [] }; } }
  function byKey(k) { var V = window.UTVW_VEHICLES || []; for (var i = 0; i < V.length; i++) if (V[i].k === k) return V[i]; return null; }
  function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function vehicleTags() {
    var g = garage(), tags = [];
    g.list.forEach(function (v) {
      var meta = byKey(v.k); if (!meta) return;
      [ 'garage-' + v.k, 'garage-' + v.k + '-' + v.y, 'garage-mk-' + slug(meta.mk) ].forEach(function (t) { if (tags.indexOf(t) < 0) tags.push(t); });
    });
    if (tags.length) tags.push('has-garage');
    return tags;
  }
  function labels() {
    return garage().list.map(function (v) { var m = byKey(v.k); return m ? v.y + ' ' + m.mk + ' ' + m.md : ''; }).filter(Boolean).join('; ');
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelector) return;
    var t = f.querySelector('input[name="contact[tags]"]'); if (!t) return;
    var base = (t.getAttribute('data-base') || t.value || 'newsletter');
    t.setAttribute('data-base', base);
    var extra = vehicleTags();
    t.value = base.split(',').concat(extra).filter(function (x, i, a) { return x && a.indexOf(x) === i; }).join(',');
    var note = f.querySelector('[data-utvw-ride-note]');
    if (note) note.value = labels() ? 'My Garage: ' + labels() : '';
  }, true);
  // keep the active vehicle on the cart so it appears on the order
  var last = ''; try { last = sessionStorage.getItem('utvw_cart_veh') || ''; } catch (e) {}
  function syncCart() {
    var g = garage(), a = (g.active && g.active.k) ? g.active : g.list[0];
    var m = a && byKey(a.k);
    var val = m ? a.y + ' ' + m.mk + ' ' + m.md : '';
    if (val === last) return; last = val; try { sessionStorage.setItem('utvw_cart_veh', val); } catch (e) {}
    try {
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ attributes: { 'Vehicle': val, 'Vehicle key': a ? a.k + '|' + a.y : '' } })
      }).catch(function () {});
    } catch (e) {}
  }
  document.addEventListener('utvw:garage', syncCart);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCart); else syncCart();
})();

/* ==========================================================================
   Ride Hub: podium vehicle picker with real vehicle photos, year save,
   vehicle-matched tips and newest parts.
   ========================================================================== */
(function () {
  'use strict';
  var V = window.UTVW_VEHICLES || [];
  if (!V.length) return;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Fallback when a model has no photo yet: a clean name plate, never drawn art.
  function art(v) { return '<span class="utvw-rh__plate"><small>' + esc(v.mk) + '</small><strong>' + esc(shortMd(v.md)) + '</strong></span>'; }
  function shortMd(md) { return md.split(' / ')[0].replace(/\s*\(.*\)\s*$/, ''); }
  function esc(x) { return String(x).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function garage() { try { return JSON.parse(localStorage.getItem('utvw_garage_v1') || 'null') || { list: [] }; } catch (e) { return { list: [] }; } }
  function saveVehicle(k, y) {
    var g = garage(); g.list = (g.list || []).filter(function (x) { return !(x.k === k && +x.y === +y); });
    g.list.unshift({ k: k, y: +y }); g.list = g.list.slice(0, 6); g.active = { k: k, y: +y };
    try { localStorage.setItem('utvw_garage_v1', JSON.stringify(g)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('utvw:garage', { detail: g }));
  }

  function Hub(root) {
    this.root = root;
    this.track = root.querySelector('[data-rh-track]');
    this.ph = {}; try { this.ph = JSON.parse(root.querySelector('[data-rh-photos]').textContent || '{}'); } catch (e) {}
    var ov = {}; try { ov = JSON.parse(root.querySelector('[data-rh-images]').textContent || '{}'); } catch (e) {}
    for (var ok in ov) this.ph[ok] = { i: ov[ok], t: ov[ok], own: 1 };
    this.credit = root.querySelector('[data-rh-credit]');
    this.base = root.getAttribute('data-collections') || '/collections';
    this.blog = root.getAttribute('data-blog') || '';
    this.feed = !!root.getAttribute('data-feed');
    this.make = 'All';
    var popular = V.filter(function (v) { return v.p; }), rest = V.filter(function (v) { return !v.p; });
    this.all = popular.concat(rest);
    this.list = this.all.slice();
    var g = garage(), a = g.active && g.active.k ? g.active : (g.list && g.list[0]);
    this.i = 0;
    if (a) { for (var j = 0; j < this.list.length; j++) if (this.list[j].k === a.k) this.i = j; }
    var q = (location.search.match(/[?&]ride=([a-z0-9-]+)/) || [])[1];
    if (q) { for (var m = 0; m < this.list.length; m++) if (this.list[m].k === q) this.i = m; }
    this.buildMakes(); this.render(); this.bind(); this.select(this.i, true);
  }
  Hub.prototype.buildMakes = function () {
    var self = this, wrap = this.root.querySelector('[data-rh-makes]'), makes = ['All'];
    V.forEach(function (v) { if (makes.indexOf(v.mk) < 0) makes.push(v.mk); });
    wrap.innerHTML = makes.map(function (m) { return '<button type="button" role="tab" data-mk="' + esc(m) + '" aria-selected="' + (m === 'All') + '">' + esc(m) + '</button>'; }).join('');
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      self.make = b.getAttribute('data-mk');
      wrap.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      var cur = self.list[self.i];
      self.list = self.make === 'All' ? self.all.slice() : self.all.filter(function (v) { return v.mk === self.make; });
      var ni = 0; for (var j = 0; j < self.list.length; j++) if (cur && self.list[j].k === cur.k) ni = j;
      self.render(); self.select(ni, true);
    });
  };
  Hub.prototype.render = function () {
    var self = this;
    this.track.innerHTML = this.list.map(function (v, i) {
      var p = self.ph[v.k];
      return '<div class="utvw-rh__car' + (p ? '' : ' is-plate') + '" data-i="' + i + '" role="group" aria-roledescription="slide" aria-label="' + esc(v.mk + ' ' + v.md) + '">' +
        (p ? '<img src="' + esc(p.i) + '" alt="' + esc(v.mk + ' ' + shortMd(v.md) + (p.p ? ' (pictured: ' + p.p + ')' : '')) + '" ' + (i === self.i ? 'fetchpriority="high"' : 'loading="lazy"') + ' decoding="async" draggable="false" width="1200" height="720">' : art(v)) + '</div>';
    }).join('');
    var th = this.root.querySelector('[data-rh-thumbs]');
    th.innerHTML = this.list.map(function (v, i) {
      return '<button type="button" role="tab" data-i="' + i + '" aria-label="' + esc(v.mk + ' ' + v.md) + '"><span class="utvw-rh__tart">' + (self.ph[v.k] ? '<img src="' + esc(self.ph[v.k].t) + '" alt="" loading="lazy" decoding="async" width="300" height="180">' : art(v)) + '</span><span class="utvw-rh__tname">' + esc(shortMd(v.md)) + '</span></button>';
    }).join('');
    this.cars = Array.prototype.slice.call(this.track.children);
  };
  Hub.prototype.layout = function () {
    var n = this.cars.length, i = this.i, narrow = window.innerWidth < 750;
    this.cars.forEach(function (el, j) {
      var d = j - i; if (d > n / 2) d -= n; if (d < -n / 2) d += n;
      var ad = Math.abs(d), x, sc, op, z, bl;
      if (d === 0) { x = 0; sc = 1; op = 1; z = 5; bl = 0; }
      else if (ad === 1) { x = d * (narrow ? 64 : 52); sc = narrow ? .32 : .38; op = .5; z = 4; bl = 1.5; }
      else if (ad === 2) { x = d * (narrow ? 90 : 72); sc = .24; op = narrow ? 0 : .18; z = 3; bl = 3; }
      else { x = d > 0 ? 90 : -90; sc = .2; op = 0; z = 1; bl = 4; }
      el.style.transform = 'translate3d(' + x + '%,' + (d === 0 ? 0 : (narrow ? 6 : 10)) + '%,0) scale(' + sc + ')';
      el.style.opacity = op; el.style.zIndex = z; el.style.filter = bl ? 'blur(' + bl + 'px) grayscale(.6)' : 'none';
      el.classList.toggle('is-active', d === 0);
      el.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
    });
  };
  Hub.prototype.select = function (i, instant) {
    var n = this.list.length; if (!n) return;
    this.i = ((i % n) + n) % n;
    var v = this.list[this.i], self = this;
    if (!instant && !RM) { this.root.classList.remove('is-driving'); void this.root.offsetWidth; this.root.classList.add('is-driving'); clearTimeout(this._dt); this._dt = setTimeout(function () { self.root.classList.remove('is-driving'); }, 900); }
    this.layout();
    this.root.querySelectorAll('[data-rh-thumbs] button').forEach(function (b, j) { b.setAttribute('aria-selected', j === self.i ? 'true' : 'false'); if (j === self.i && b.scrollIntoView && !instant) { var p = b.parentNode; p.scrollTo({ left: b.offsetLeft - p.clientWidth / 2 + b.clientWidth / 2, behavior: RM ? 'auto' : 'smooth' }); } });
    if (this.credit) {
      var p = this.ph[v.k], c = '';
      if (p && p.p) c += 'Pictured: ' + esc(p.p) + '. ';
      if (p && p.a) c += 'Photo: ' + (p.u ? '<a href="' + esc(p.u) + '" target="_blank" rel="noopener nofollow">' + esc(p.a) + '</a>' : esc(p.a)) + (p.l ? ', ' + esc(p.l) + (/CC BY/.test(p.l) ? ', background removed' : '') : '') + '.';
      this.credit.innerHTML = c; this.credit.hidden = !c;
    }
    var mk = this.root.querySelector('[data-rh-make]'), md = this.root.querySelector('[data-rh-model]');
    mk.textContent = v.mk; md.textContent = v.md;
    [mk, md].forEach(function (el) { el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in'); });
    this.root.querySelector('[data-rh-meta]').textContent = v.y[0] + '–' + v.y[1] + ' model years · ' + (this.root.getAttribute('data-garage-hint') || '');
    var g = garage(), saved = (g.list || []).filter(function (x) { return x.k === v.k; }).map(function (x) { return +x.y; });
    var yrs = []; for (var y = v.y[1]; y >= v.y[0]; y--) yrs.push(y);
    this.root.querySelector('[data-rh-years]').innerHTML = yrs.map(function (y) { return '<button type="button" data-y="' + y + '" aria-pressed="' + (saved.indexOf(y) > -1) + '">' + y + '</button>'; }).join('');
    var url = this.base.replace(/\/$/, '') + '/' + v.k + '-accessories';
    this.root.querySelectorAll('[data-rh-shop]').forEach(function (a) { a.href = url + (saved.length ? '?yr=' + saved[0] : ''); });
    this.root.querySelectorAll('[data-rh-for]').forEach(function (s) { s.textContent = 'for the ' + shortMd(v.md); });
    var rd = this.root.querySelector('[data-rh-read]'); if (rd && this.blog) rd.href = this.blog.replace(/\/$/, '') + '/tagged/veh-' + v.k;
    if (this.feed) { clearTimeout(this._ft); this._ft = setTimeout(function () { self.loadFeed(v); }, instant ? 0 : 350); }
  };
  Hub.prototype.loadFeed = function (v) {
    var self = this, tok = (this._tok = (this._tok || 0) + 1);
    var prodEl = this.root.querySelector('[data-rh-products]'), artEl = this.root.querySelector('[data-rh-articles]');
    if (prodEl) {
      prodEl.classList.add('is-loading');
      fetch(this.base.replace(/\/$/, '') + '/' + v.k + '-accessories?view=utvw-json&sort_by=created-descending', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (tok !== self._tok) return;
          prodEl.classList.remove('is-loading');
          var ps = (d.products || []).slice(0, 8);
          prodEl.innerHTML = ps.length ? ps.map(function (p, i) {
            return '<a class="utvw-rh__p" href="' + esc(p.u) + '" style="--i:' + i + '"><span class="utvw-rh__pimg">' + (p.i ? '<img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" loading="lazy">' : '') + '</span><span class="utvw-rh__pt">' + esc(p.t) + '</span><span class="utvw-rh__pp">' + esc(p.p) + '</span></a>';
          }).join('') : '<p class="utvw-rh__empty">We\'re adding parts for this machine now. Browse universal parts in the meantime.</p>';
          var c = self.root.querySelector('[data-rh-meta]'); if (c && d.count) c.textContent = v.y[0] + '–' + v.y[1] + ' · ' + d.count + ' parts that fit · ' + (self.root.getAttribute('data-garage-hint') || '');
        }).catch(function () { prodEl.classList.remove('is-loading'); });
    }
    if (artEl && this.blog) {
      artEl.classList.add('is-loading');
      var b = this.blog.replace(/\/$/, '');
      var tries = [b + '/tagged/veh-' + v.k, b + '/tagged/mk-' + v.mk.toLowerCase().replace(/\s+/g, '-'), b];
      (function next(n, acc) {
        if (n >= tries.length || acc.length >= 3) { if (tok === self._tok) show(acc); return; }
        fetch(tries[n] + '?view=utvw-json', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
          (d.articles || []).forEach(function (a) { if (acc.length < 3 && !acc.some(function (x) { return x.u === a.u; })) acc.push(a); });
          next(n + 1, acc);
        }).catch(function () { next(n + 1, acc); });
      })(0, []);
    }
    function show(list) {
      artEl.classList.remove('is-loading');
      artEl.innerHTML = list.length ? list.map(function (a, i) {
        return '<a class="utvw-rh__a" href="' + esc(a.u) + '" style="--i:' + i + '">' + (a.i ? '<span class="utvw-rh__aimg"><img src="' + esc(a.i) + '" alt="" loading="lazy"></span>' : (self.ph[v.k] ? '<span class="utvw-rh__aimg utvw-rh__aimg--veh"><img src="' + esc(self.ph[v.k].t) + '" alt="" loading="lazy"></span>' : '<span class="utvw-rh__aimg utvw-rh__aimg--art">' + art(v) + '</span>')) +
          '<span class="utvw-rh__ab"><small>' + esc(a.d || '') + '</small><strong>' + esc(a.t) + '</strong><span>' + esc(a.x || '') + '</span></span></a>';
      }).join('') : '<p class="utvw-rh__empty">Guides for this machine are on the way.</p>';
    }
  };
  Hub.prototype.bind = function () {
    var self = this, root = this.root;
    root.querySelector('[data-rh-prev]').addEventListener('click', function () { self.select(self.i - 1); });
    root.querySelector('[data-rh-next]').addEventListener('click', function () { self.select(self.i + 1); });
    root.querySelector('[data-rh-thumbs]').addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) self.select(+b.getAttribute('data-i')); });
    this.track.addEventListener('click', function (e) { var c = e.target.closest('.utvw-rh__car'); if (c && !c.classList.contains('is-active')) self.select(+c.getAttribute('data-i')); });
    root.querySelector('[data-rh-years]').addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var v = self.list[self.i], y = +b.getAttribute('data-y');
      saveVehicle(v.k, y);
      root.querySelectorAll('[data-rh-years] button').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      root.querySelectorAll('[data-rh-shop]').forEach(function (a) { a.href = self.base.replace(/\/$/, '') + '/' + v.k + '-accessories?yr=' + y; });
      root.classList.remove('is-saved'); void root.offsetWidth; root.classList.add('is-saved');
    });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('input,select,textarea')) return;
      if (e.key === 'ArrowRight') { self.select(self.i + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { self.select(self.i - 1); e.preventDefault(); }
    });
    var sx = null, sy = null, stage = root.querySelector('[data-rh-stage]');
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; }, { passive: true });
    stage.addEventListener('pointerup', function (e) {
      if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.select(self.i + (dx < 0 ? 1 : -1));
    }, { passive: true });
    if (!RM && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        root.style.setProperty('--rx', x.toFixed(3)); root.style.setProperty('--ry', y.toFixed(3));
      }, { passive: true });
    }
    window.addEventListener('resize', function () { self.layout(); }, { passive: true });
  };
  function init() { document.querySelectorAll('[data-utvw-ride-hub]').forEach(function (r) { if (!r.__rh) r.__rh = new Hub(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ==========================================================================
   UTV Wholesaler Club: size + vehicle tags on join, success focus, hero parallax.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-utvw-club]');
  if (!root) return;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.classList || !f.classList.contains('utvw-club__f')) return;
    var t = f.querySelector('input[name="contact[tags]"]'), sz = f.querySelector('[data-club-size]'), note = f.querySelector('[data-club-note]');
    var size = sz && sz.value ? sz.value : '';
    if (t) {
      var tags = t.value.split(',').filter(Boolean);
      if (tags.indexOf('club-member') < 0) tags.push('club-member');
      if (size) tags.push('club-size-' + size.toLowerCase());
      t.value = tags.filter(function (x, i, a) { return a.indexOf(x) === i; }).join(',');
    }
    if (note) {
      var ride = ''; var lab = document.querySelector('[data-utvw-active-label]');
      try { var g = JSON.parse(localStorage.getItem('utvw_garage_v1') || 'null'); if (g && g.list && g.list.length && lab) ride = lab.textContent.trim(); } catch (err) {}
      note.value = 'UTV Wholesaler Club member (joined ' + new Date().toISOString().slice(0, 10) + ')' + (size ? ' | Shirt size: ' + size : '') + (ride ? ' | Ride: ' + ride : '');
    }
  }, true);
  var ok = root.querySelector('[data-club-ok]');
  if (ok) { var j = ok.closest('.utvw-club__join-wrap'); if (j && j.scrollIntoView) j.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); root.classList.add('is-joined'); }
  if (RM) return;
  var vis = root.querySelector('.utvw-club__visual'); if (!vis) return;
  var tick = false;
  function frame() {
    tick = false;
    var r = vis.getBoundingClientRect(), vh = window.innerHeight || 800;
    var p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / vh));
    vis.style.setProperty('--cp', p.toFixed(3));
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(frame); } }, { passive: true });
  frame();
})();
